// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"0f297378","157":"0f297378","189":"0f297378","191":"5c078dc3","682":"0e7c032d","826":"d6a49f42"}[chunkId] + ".chunk.css";
};